import { render } from "./BaseToggleButton.vue?vue&type=template&id=72612c89"
import script from "./BaseToggleButton.vue?vue&type=script&lang=js"
export * from "./BaseToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__